import { mergeProps, Show } from 'solid-js';
import { APPLICATION_TYPE_CONFIG, getTranslationKey } from './utils';
import { getLocalizedString } from '~/i18n/utils';
import { EApplicationType } from '~/api';
import { IndividualApplicationContent } from './IndividualApplicationContent';

type ApplicationTypeContentProps = {
  type: EApplicationType;
  showDescription?: boolean;
  showTagList?: boolean;
  showIcon?: boolean;
  class?: string;
};

export default function ApplicationTypeContent(
  props: ApplicationTypeContentProps
) {
  const merged = mergeProps(
    { showDescription: true, showTagList: true, showIcon: true },
    props
  );

  const config = () =>
    APPLICATION_TYPE_CONFIG.find((item) => item.type === merged.type);

  return (
    <div>
      <Show when={config()}>
        {(item) => {
          const c = item();
          return (
            <IndividualApplicationContent
              applicationName={getLocalizedString(getTranslationKey(c.name))}
              description={getLocalizedString(getTranslationKey(c.description))}
              tagsList={[...c.tags]}
              showDescription={merged.showDescription}
              showTagList={merged.showTagList}
              applicationType={merged.type}
              showIcon={merged.showIcon}
              class={merged?.class}
            />
          );
        }}
      </Show>
    </div>
  );
}
